import React from 'react';
import '../styles/theme.css';
import '../styles/Portfolio.css';
import PortfolioTopNav from '../components/PortfolioTopNav';
import Footer from '../components/Footer';
import PortfolioContent from '../components/PortfolioContent';
/* IMPORTS */

function PortfolioPage() {
  return (
    <div className="po-root">
      <div id="portfoliotopnav" className="po-slot-portfoliotopnav">
        <PortfolioTopNav activePage={"Portfolio"} />
      </div>
      <div id="portfoliocontent" className="po-slot-portfoliocontent">
        <PortfolioContent />
      </div>
      <div id="footer" className="po-slot-footer">
        <Footer />
      </div>
    </div>
  );
}

export default PortfolioPage;